/**
 * Information of supported browsers
 *
 * File: \src\components\login\SupportedBrowsersDialog.ts
 * Created Date: Monday, August 5th 2019, 13:15:17
 * Author: Ali Baris Uzuner
 * -----
 * Last Modified: July 16th 2024, 13:11:36
 * Modified By: Boryana Kircheva
 * -----
 * Copyright (c) 2017-2019 Liebherr-Hausgeräte GmbH
 */

import { defineComponent } from 'vue';
import AssetHelper from '@/components/general/assets/AssetHelper';

export default defineComponent({
  props: {
    /**Controls dialog visibility */
    dialogShown: { type: Boolean, default: false }
  },
  setup() {
    return {
      AssetHelper
    };
  }
});
